module.exports = __webpack_public_path__ + "static/media/U_rybnicka.52154d7b.md";